import { OwnerReportOutput } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportColumnConfig } from 'modules/reports/types';
import { formatDateSafe } from 'modules/reports/utils/formatDateSafe';

import { formatOwnerDonors } from './utils/formatOwnerDonors';

export const getOwnerReportColumns = (
  t: TFunction
): ReportColumnConfig<OwnerReportOutput>[] => [
  {
    key: 'id',
    label: t('id'),
    getValue: (item) => item.id || '',
  },
  {
    key: 'shortId',
    label: t('shortId'),
    getValue: (item) => item.shortId ?? '',
  },
  {
    key: 'email',
    label: t('email'),
    getValue: (item) => item.email || '',
  },
  {
    key: 'firstName',
    label: t('firstName'),
    getValue: (item) => item.firstName || '',
  },
  {
    key: 'lastName',
    label: t('lastName'),
    getValue: (item) => item.lastName || '',
  },
  {
    key: 'phoneNumber',
    label: t('phoneNumber'),
    getValue: (item) => item.phoneNumber || '',
  },
  {
    key: 'streetAddress',
    label: t('streetAddress'),
    getValue: (item) => item.streetAddress || '',
  },
  {
    key: 'city',
    label: t('city'),
    getValue: (item) => item.city || '',
  },
  {
    key: 'state',
    label: t('state'),
    getValue: (item) => item.state || '',
  },
  {
    key: 'zipCode',
    label: t('zipCode'),
    getValue: (item) => item.zipCode || '',
  },
  {
    key: 'locationPreferences',
    label: t('locationPreferences'),
    getValue: (item) => item.locationPreferences || '',
  },
  {
    key: 'regions',
    label: t('regions'),
    getValue: (item) => item.regions.join(', '),
  },
  {
    key: 'regionPreferences',
    label: t('regionPreferences'),
    getValue: (item) => item.regionPreferences || '',
  },
  {
    key: 'type',
    label: t('type'),
    getValue: (item) => item.type || '',
  },
  {
    key: 'isArchived',
    label: t('isArchived'),
    getValue: (item) => (item.isArchived ? 'Yes' : 'No'),
  },
  {
    key: 'contactPreferences',
    label: t('contactPreferences'),
    getValue: (item) => item.contactPreferences || '',
  },
  {
    key: 'birthday',
    label: t('birthday'),
    getValue: (item) => formatDateSafe(item.birthday),
  },
  {
    key: 'donors',
    label: t('donors'),
    getValue: (item) => formatOwnerDonors(item.donors),
  },
];
